// src/config/servicePaused.js
//
// Interruptor unico de la pausa del servicio (21-sep-2026).
//
// Con SERVICE_PAUSED en true:
//   - cualquier usuario que no sea admin ve la pantalla de pausa en el
//     dashboard y en /app, sin llegar a partidos, senales ni historial;
//   - checkout, paywall y registro quedan cerrados: nadie puede pagar ni
//     crear cuenta;
//   - la landing y las paginas publicas siguen visibles, con un banner;
//   - el admin entra a todo como siempre.
//
// Para reactivar el servicio: poner false aca, `npm run build` y desplegar.
// No hay otro lugar donde tocar.
//
// Por que una constante y no un flag remoto (Remote Config o la base en
// tiempo real): un flag remoto que falla al leerse deja el sitio abierto,
// que es justo el error que no queremos. Esto no depende de la red ni del
// estado de la sesion, y se puede auditar leyendo el archivo.

export const SERVICE_PAUSED = true;

// Fecha en que entro la pausa. Solo informativa, para el log de despliegue.
export const PAUSED_SINCE = '2026-09-21';

export const PAUSE_COPY = {
  titulo: 'Edge Elite está en pausa',
  cuerpo:
    'Edge Elite está en pausa mientras preparamos una nueva versión. Gracias por tu apoyo.',
  // Variante corta para el banner de la landing y las paginas publicas.
  banner:
    'Edge Elite está en pausa mientras preparamos una nueva versión. Gracias por tu apoyo.',
  // Lo que se muestra donde antes habia un boton de pago.
  pago: 'Los pagos están desactivados mientras el servicio está en pausa.',
  // Lo que se muestra en el registro.
  registro: 'El registro está cerrado mientras el servicio está en pausa.',
};

/**
 * True si a este usuario hay que mostrarle la pausa.
 * El admin nunca queda bloqueado.
 */
export function isPausedFor(isAdmin) {
  return SERVICE_PAUSED && !isAdmin;
}
